import { IoHomeOutline } from 'react-icons/io5'
import { IoCalendarOutline } from 'react-icons/io5'
import { PiChats } from 'react-icons/pi'
import { FiArchive } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'
import { CgProfile } from 'react-icons/cg'
import { MdManageHistory } from 'react-icons/md'
import { ReactComponent as DoctorIcon } from '../../assets/images/doctors.svg'
import { BsPeople } from 'react-icons/bs'
import { ROLES } from 'utils/constants'
const { ADMIN, COUNSELOR } = ROLES

const SidebarItems = [
  {
    title: 'Menu',
    items: [
      {
        title: 'Home',
        path: '/dashboard',
        icon: IoHomeOutline,
        allowed: [COUNSELOR],
      },
      {
        title: 'Home',
        path: '/admin-dashboard',
        icon: IoHomeOutline,
        allowed: [ADMIN],
      },
      {
        title: 'Calendar',
        path: '/calendar',
        icon: IoCalendarOutline,
        allowed: [ADMIN, COUNSELOR],
      },
      {
        title: 'Active chats',
        path: '/active-chats',
        icon: PiChats,
        allowed: [ADMIN, COUNSELOR],
      },
      {
        title: 'Archive chats',
        path: '/archive-chats',
        icon: FiArchive,
        allowed: [ADMIN, COUNSELOR],
      },

      {
        title: 'Providers',
        path: '/counselors',
        icon: BsPeople,
        allowed: [ADMIN],
      },
      {
        title: 'Rotas',
        path: '/rotas',
        icon: MdManageHistory,
        allowed: [ADMIN],
      },
      {
        title: 'Providers',
        path: '/doctors',
        icon: DoctorIcon,
        allowed: [COUNSELOR],
      },
    ],
  },
  {
    title: 'Other',
    items: [
      {
        title: 'Profile',
        path: '/profile',
        icon: CgProfile,
        allowed: [ADMIN, COUNSELOR],
      },
      {
        title: 'Settings',
        path: '/settings',
        icon: IoSettingsOutline,
        allowed: [ADMIN, COUNSELOR],
      },
    ],
  },
]
export default SidebarItems
